import _styled from "styled-components";
import React, { useContext } from 'react';
import { GridContext } from './GridContext';
import * as styles from './Grid.style';
const GridUnit = _ref => {
  let {
    children,
    size,
    addCss
  } = _ref;
  const {
    gutter
  } = useContext(GridContext);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $size: size,
    $gutter: gutter,
    $addCss: addCss,
    $_css: styles.unit
  }, children);
};
GridUnit.defaultProps = {
  size: 1
};
export default GridUnit;
var _StyledDiv = _styled("div").withConfig({
  displayName: "GridUnit___StyledDiv",
  componentId: "sc-11m4kp-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=GridUnit.js.map